<template>
  <v-container v-if="activity" fluid class="pa-0" :style="'filter: blur(4px)'">
    <ActivityHero :has-subscription="false" :activity="activity" />
    <div class="py-4">
      <v-expansion-panels v-model="openPanels" multiple accordion>
        <v-expansion-panel expand>
          <v-expansion-panel-content>
            <v-row no-gutters>
              <v-col cols="12" md="8">
                <!-- eslint-disable-next-line vue/no-v-html -->
                <div class="mt-4 activityText" v-html="activity.content" />
                <ActivityAmenitiesList
                  :amenities="activity.activity_features"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-container class="activitySidebar">
                  <AuthorCard
                    class="mb-4"
                    :author="activity.created_by || {}"
                    :source="activity.source"
                    :items="recentByAuthor"
                    type="activities"
                  />
                  <ActivityMap :activity="activity" />
                </v-container>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel
          v-if="activity.things_to_bring && activity.things_to_bring.length"
        >
          <v-expansion-panel-header>
            <div class="text-h4 text-md-h3 secondary--text">
              Things to Bring
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <ActivityAmenitiesList
              :amenities="activity.things_to_bring"
              :title="false"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="activity.tips && activity.tips.length">
          <v-expansion-panel-header>
            <div class="text-h4 text-md-h3 secondary--text">
              Tips
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <ul>
              <li>{{ activity.tips }}</li>
            </ul>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div class="text-h4 text-md-h3 secondary--text">
              Adventures Nearby
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <NearbyRecommendations :activity="activity" />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-col>
        <!-- <Comments type="activity" :model="activity" />-->
        <RecommendedGear :activity="activity" />
        <PartnerAd />
      </v-col>
    </div>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import ActivityHero from '@/components/activity/ActivityHero'
import ActivityMap from '@/components/activity/ActivityMap'
import ActivityAmenitiesList from '@/components/activity/ActivityAmenitiesList'
import NearbyRecommendations from '@/components/activity/NearbyRecommendations'
import RecommendedGear from '@/components/activity/RecommendedGear'
import PartnerAd from '@/components/ads/PartnerAd'
import AuthorCard from '@/components/AuthorCard'

export default {
  name: 'ActivityPage',
  components: {
    ActivityAmenitiesList,
    ActivityHero,
    ActivityMap,
    NearbyRecommendations,
    RecommendedGear,
    AuthorCard,
    PartnerAd,
  },
  async asyncData({ params, store, $axios, error }) {
    try {
      await store.dispatch('activities/LOAD_ACTIVITY/REQUEST', {
        id: params.slug,
      })

      const url = `/api/v2/activities/${params.slug}/`
      const { data: activity } = await $axios.get(url)
      let recentByAuthor = []

      if (activity.created_by) {
        const recentUrl = `/api/v2/activities/?created_by=${activity.created_by.id}&page_size=3`
        const {
          data: { results },
        } = await $axios.get(recentUrl)
        // TODO: Add this filter to endpoint
        recentByAuthor = results.filter((act) => act.id !== activity.id)
      }

      return {
        recentByAuthor,
      }
    } catch (err) {
      if (err.response && err.response.status === 404) {
        return error({ statusCode: 404, message: err.message })
      } else {
        error(err.message)
      }
    }
  },
  data: () => ({
    openPanels: [0],
  }),
  computed: {
    ...mapState({
      activity: (state) => state.activities.activity,
    }),
  },
  mounted() {
    // Send event to Facebook Pixel
    this.$fb.track('ViewContent', {
      resource: 'Activity',
      details: { id: this.activity.id, name: this.activity.headline },
    })
  },
  head() {
    const {
      header_optimized: headerOptimized,
      short_description: description,
      slug,
      headline,
    } = this.activity

    const name = `Happyly: ${headline}`
    const url = `${process.env.PUBLIC_URL}/activity/${slug}`
    const image = headerOptimized
      ? `${this.$config.staticUrl}${headerOptimized}`
      : `${this.$config.staticUrl}/media/happyly_Logo_dwt.f9715d34.png`

    return {
      title: name,
      meta: [
        { hid: 'description', name: 'description', content: description },
        { hid: 'image', name: 'image', content: image },
        { hid: 'twitter:title', name: 'twitter:title', content: name },
        {
          hid: 'twitter:description',
          name: 'twitter:description',
          content: description,
        },
        { hid: 'twitter:image:src', name: 'twitter:image:src', content: image },
        { hid: 'og:title', property: 'og:title', content: name },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description,
        },
        { hid: 'og:image', property: 'og:image', content: image },
        { hid: 'og:image:alt', property: 'og:image:alt', content: name },
        { hid: 'og:url', property: 'og:url', content: url },
      ],
      link: [
        {
          rel: 'canonical',
          href: process.env.PUBLIC_URL + '/' + this.$route.path,
        },
      ],
    }
  },
}
</script>

<style lang="scss">
@import '@/assets/styles/dialog.scss';
.activitySidebar {
  position: sticky;
  top: 80px;
}
</style>
